import type { Extension } from "@medplum/fhirtypes";
import { asMemberId, type ObservationLevel } from "@repo/domain";
import { OBSERVATION_LEVEL_URL } from "@repo/fhir-systems/extensions";

export function readObservationLevels(extensions: Extension[] = []): ObservationLevel[] | undefined {
  const entries = extensions.filter((entry) => entry.url === OBSERVATION_LEVEL_URL);
  if (!entries.length) return undefined;
  return entries.map((entry) => {
    const id = entry.extension?.find((field) => field.url === "observationId")?.valueString;
    const level = entry.extension?.find((field) => field.url === "level")?.valueCode;
    if (!id || level !== "trial") throw new Error("Unreadable observation level plan");
    return { observationId: asMemberId(id), level };
  });
}

export function writeObservationLevels(plan: readonly ObservationLevel[] = []): Extension[] {
  return plan.map((entry) => ({
    url: OBSERVATION_LEVEL_URL,
    extension: [
      { url: "observationId", valueString: entry.observationId },
      { url: "level", valueCode: entry.level },
    ],
  }));
}
